<template>
  <div v-if="content">
    <Carrousel :slides="slides"/>
    <section class="mt-5">
      <div class="container" >
        <div class="row">
          <div class="col-lg-12">
            <h1 class="page-title">
              {{title}}
            </h1>
            <div class="page-description" v-html="htmlContent"></div>
          </div>
        </div>
      </div>
    </section>
    <Widgets/>
    <EventRecents v-if="lastEvents"/>
  </div>
</template>

<script>
import Widgets from "./Widgets";
import { mapGetters } from "vuex";
import Carrousel from "../../components/Carrousel";
import { i18nText } from '../../shared/helpers/i18nText';
import EventRecents from "../../components/events/CarrouselRecents";

export default {
  name: "Home",
  data() {
    return {
      slides: [],
      content: null,
      title: "",
      description: "",
      lastEvents: true
    }
  },
  components: {
    Carrousel,
    Widgets,
    EventRecents
  },
  filters: {
    toHtml(value) {
      return value.replace(/(?:\r\n|\r|\n)/g, '<br>')
    }
  },
  methods: {
    async fetch() {
      try {
        const response = await this.$http.get(`/api/v2/home`)

        if(response.status == 200 || response.status == 304) {
          return response.data.preference
        } else {
          return []
        }
      } catch (e) {
        //location.href = "/"
        alert("[ERROR]: Load preferences")
        console.log(e)
      }
    }
  },
  computed: {
    ...mapGetters('Preference', ['currentPreference']),
    htmlContent() {
      return this.$options.filters.toHtml(this.description);
    }
  },
  async created() {
    this.content = await this.fetch();
    this.slides = this.content.banners;
    this.title = i18nText(this.$i18n.locale, this.content.texts, "title");
    this.description = i18nText(this.$i18n.locale, this.content.texts, "description");
    this.lastEvents = this.currentPreference.last_events;
  },
  watch: {
    "$i18n.locale"() {
      if (this.content) { 
        this.title = i18nText(this.$i18n.locale, this.content.texts, "title");
        this.description = i18nText(this.$i18n.locale, this.content.texts, "description");
      }
    }
  }
}
</script>

<style scoped>
  .page-title {
    text-align: center;
  }
  .page-description {
    margin-top: 25px;
    margin-bottom: 30px;
    font-weight: 300;
    font-size: 20px;
    line-height: 23px;
    font-style: normal;
    text-align: center;
  }
</style>
